import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


function createData(empCode, empName, totalDays, leaves, uanNo, pfNo, basic, basicOfPF, gross, epf, eps, epf_eps, total, edli) {
  return { empCode, empName, totalDays, leaves, uanNo, pfNo, basic, basicOfPF, gross, epf, eps, epf_eps, total, edli };
}

const rows = [
  createData(123, 'Ankur Kumar', 30, 0, 12434, 122, 7500, 7500, 7500, 900, 625, 275, 900, 38),
];




export default function PFReportTable() {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Employee Code</TableCell>
            <TableCell align="left">Employee Name</TableCell>
            <TableCell align="right">Total Number of days</TableCell>
            <TableCell align="right">Leaves</TableCell>
            <TableCell align="right">UAN Number</TableCell>
            <TableCell align="right">PF Number</TableCell>
            <TableCell align="right">Basic</TableCell>
            <TableCell align="right">Basic of PF</TableCell>
            <TableCell align="right">Gross</TableCell>
            <TableCell align="right">EPF</TableCell>
            <TableCell align="right">EPS</TableCell>
            <TableCell align="right">EPF-EPS</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell align="right">EDLI</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.empCode}
              </TableCell>
              <TableCell align="left">{row.empName}</TableCell>
              <TableCell align="right">{row.totalDays}</TableCell>
              <TableCell align="right">{row.leaves}</TableCell>
              <TableCell align="right">{row.uanNo}</TableCell>
              <TableCell align="right">{row.pfNo}</TableCell>
              <TableCell align="right">{row.basic}</TableCell>
              <TableCell align="right">{row.basicOfPF}</TableCell>
              <TableCell align="right">{row.gross}</TableCell>
              <TableCell align="right">{row.epf}</TableCell>
              <TableCell align="right">{row.eps}</TableCell>
              <TableCell align="right">{row.epf_eps}</TableCell>
              <TableCell align="right">{row.total}</TableCell>
              <TableCell align="right">{row.edli}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
